// @flow

import React from 'react';
import classNames from 'classnames';
import beeImage from 'assets/client/images/bee_pop-up.svg';
import { PREVIEW_ROUTE, STARS_TITLES } from 'client/constants';
import _ from 'lodash';
import StarsRating from '../../StarsRating';

import * as css from './VotePopUp.scss';

type Props = {
	setPopUp: Function,
	match: RouterMatch,
	item: Item,
	saveUserChoice: (data: SaveVoteReqOpts) => Promise<any>,
	setIsVoted: Function,
};

type State = {
	item: Item,
	isVoited: boolean,
	votedRate: number,
	textCanChangeVote: string,
};

class VotePopUp extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			item: props.item,
			isVoited: false,
			votedRate: 0,
			textCanChangeVote: '',
		};
	}

	get isPreviewMode() {
		const { match } = this.props;

		return match.path === PREVIEW_ROUTE;
	}

	onRatingClick = async (rating: number) => {
		switch (rating) {
			case 10:
			case 20:
				this.setState({ textCanChangeVote: STARS_TITLES.ONE });
				break;
			case 30:
			case 40:
				this.setState({ textCanChangeVote: STARS_TITLES.TWO });
				break;
			case 50:
			case 60:
				this.setState({ textCanChangeVote: STARS_TITLES.THREE });
				break;
			case 70:
			case 80:
				this.setState({ textCanChangeVote: STARS_TITLES.FOUR });
				break;
			case 90:
			case 100:
				this.setState({ textCanChangeVote: STARS_TITLES.FIVE });
				break;
			default:
				break;
		}

		this.setState({ votedRate: rating });
	};

	saveRating = async (e: SyntheticMouseEvent<HTMLButtonElement>) => {
		const { item, votedRate } = this.state;
		const { saveUserChoice, setIsVoted } = this.props;

		if (votedRate !== 0 && item) {
			if (!this.isPreviewMode) {
				const saveHandler = await saveUserChoice({ id: _.get(item, 'id'), rate: Number(votedRate) });
				if (saveHandler.success) {
					setIsVoted(votedRate);
				}
			} else if (item.usersRate !== undefined && item.votes !== undefined) {
				setIsVoted(votedRate);
				// this.setState({
				// 	usersRate: Math.round((item.usersRate * item.votes + Number(votedRate)) / (item.votes + 1)),
				// });
			}
			this.setState({ isVoited: true });

			setTimeout(() => {
				this.props.setPopUp(null);
			}, 4000);
		}
	};

	render() {
		const { votedRate, isVoited, textCanChangeVote } = this.state;
		const textCanVote = 'לחצו על הכוכבים לבחירת דירוג';
		// const textCanChangeVote = 'חובה צפייה!';
		const btnText = 'דירגתי';
		const topText = votedRate !== 0 ? textCanChangeVote : textCanVote;
		const finishText = 'הדירוג שלך התקבל, תודה';

		return (
			<div className={classNames(css.votePopUp, { [css.hideFinalScreen]: !isVoited })}>
				<div className={classNames(css.screen, css.voteScreen)}>
					<p className={css.text}>{topText}</p>
					<StarsRating
						ratingClick={this.onRatingClick}
						disable={isVoited}
						votedRate={votedRate}
						className={css.popUpRating}
					/>
					<button
						type="button"
						className={classNames(css.button, { [css.disabled]: votedRate === 0 })}
						onClick={this.saveRating}
					>
						{btnText}
					</button>
				</div>
				{/* Final Screen */}
				<div className={classNames(css.screen, css.finalScreen)}>
					<p className={css.text}>{finishText}</p>
					<img src={beeImage} alt="bee_pop-up" />
				</div>
			</div>
		);
	}
}

export default VotePopUp;
